import { useMemo } from 'react'

export function usePlatform() {
  return useMemo(() => {
    const isMac =
      (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData
        ?.platform === 'macOS' || /Mac/.test(navigator.platform)

    return {
      isMac,
      isWindows: !isMac,
    }
  }, [])
}
